import { usePageContext } from 'application/contexts/PageContext';
import { ReadMore } from 'designsystem/components/2-molecules/ReadMore';
import { LinkFeature } from 'features/Modules/Link';
import { fireAdobeEvent } from 'helpers/adobeEvent';

export const ReadMoreFeature: React.FC<Content.ReadMore> = ({ content }) => {
	const pageContext = usePageContext();
	const handleCallback = (link: Content.Link) => {
		const pageName = pageContext.documentType === 'articlePage' ? pageContext.name : 'ikke en emne tekst side';
		const linkType = link.route ? 'internal' : 'external';
		let href: string;

		try {
			if (link.route) {
				href = new URL(link.route?.path, `${document.location.protocol}//${document.location.host}`).toString();
			} else {
				href = link.url;
			}
		} catch {
			href = link.url;
		}

		fireAdobeEvent('emne_tekst_rm_click', {
			linkName: link.title,
			linkType: linkType,
			pageName: pageName,
			href,
		});
	};

	return (
		<ReadMore
			heading={content.properties.heading}
			links={content.properties.links.map((link, index) => {
				return <LinkFeature key={index} {...link} style="arrow" callback={() => handleCallback(link)} />;
			})}
		/>
	);
};
